import React, { FC } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'

import useInitializationQuill from 'shared/hooks/useInitializationQuill'
import { useScrollToTop } from 'shared/hooks'
import { SubscribeToUser } from 'modulesCommon/SubscribeToUser'
import { MessagesDialog } from 'modules/Messages/containers'
import { DEV } from 'components/__dev__'

const MainLayoutContainer: FC = () => {
  useScrollToTop()
  const { isQuillInitialized } = useInitializationQuill()

  return (
    <HelmetProvider>
      <DEV.UserBanner />
      <MessagesDialog />
      <SubscribeToUser />
      {isQuillInitialized ? <Outlet /> : null}
    </HelmetProvider>
  )
}

export default MainLayoutContainer
